<script>
import DatePicker from "vue2-datepicker";
export default {
  name: "POSearchModal",
  components: {
    DatePicker,
  },
  data() {
    return {
      modalTitle: "",
      loading: false,
      deadlineList: [],
      accomplishmentDeadline: {
        type: "",
        referenceType: "",
        referenceId: 0,
        deadline: null,
        cycle: this.$store.state.data.cycle,
      },
      returnDeadline: {
        type: "",
        referenceType: "",
        referenceId: 0,
        deadline: null,
        cycle: this.$store.state.data.cycle,
      },
      error: 0,
    };
  },
  created() {},
  methods: {
    async setData(deadlineArray, title) {
      this.loading = true;
      this.modalTitle = title;
      let cycle = this.$store.state.data.cycle;
      this.deadlineList = [];
      this.$bvModal.show("submission-deadline-modal");
      await this.$store
        .dispatch("submissiondeadline/GetSubmissionDeadline", cycle)
        .then((res) => {
          deadlineArray.forEach((requestedDeadline) => {
            let deadline = res.data.find(
              (existingDeadline) =>
                existingDeadline.referenceType ===
                  requestedDeadline.referenceType &&
                existingDeadline.type === requestedDeadline.type &&
                existingDeadline.referenceId === requestedDeadline.referenceId
            );
            if (deadline) {
              deadline.deadline = new Date(deadline.deadline);
              deadline.label = requestedDeadline.label;
              this.deadlineList.push(deadline);
            } else
              this.deadlineList.push({
                label: requestedDeadline.label,
                type: requestedDeadline.type,
                referenceType: requestedDeadline.referenceType,
                referenceId: requestedDeadline.referenceId,
                deadline: null,
                cycle: this.$store.state.data.cycle,
              });
          });
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      await setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async onSave() {
      this.deadlineList.forEach((deadline) => {
        this.saveDeadline(deadline);
      });
      await this.endSave();
    },
    async saveDeadline(deadline) {
      if (deadline.deadline == "" || deadline.deadline == null) {
        if (deadline.id) {
          await this.$store
            .dispatch(
              "submissiondeadline/DeleteSubmissionDeadline",
              deadline.id
            )
            .then((res) => {
              if (res.data.error) {
                this.error = 2;
                return this.showToast(res.data.errorMessage, "error");
              }
            })
            .catch((err) => {
              this.error = 1;
            });
        }
      } else if (deadline.id) {
        deadline.deadline = this.getDate(deadline.deadline);
        await this.$store
          .dispatch("submissiondeadline/UpdateSubmissionDeadline", deadline)
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      } else {
        deadline.deadline = this.getDate(deadline.deadline);
        await this.$store
          .dispatch("submissiondeadline/CreateSubmissionDeadline", deadline)
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      }
    },
    async saveAccomplishmentDeadline() {
      if (
        this.accomplishmentDeadline.deadline == "" ||
        this.accomplishmentDeadline.deadline == null
      ) {
        if (this.accomplishmentDeadline.id) {
          await this.$store
            .dispatch(
              "submissiondeadline/DeleteSubmissionDeadline",
              this.accomplishmentDeadline.id
            )
            .then((res) => {
              if (res.data.error) {
                this.error = 2;
                return this.showToast(res.data.errorMessage, "error");
              }
            })
            .catch((err) => {
              this.error = 1;
            });
        }
      } else if (this.accomplishmentDeadline.id) {
        this.accomplishmentDeadline.deadline = this.getDate(
          this.accomplishmentDeadline.deadline
        );
        await this.$store
          .dispatch(
            "submissiondeadline/UpdateSubmissionDeadline",
            this.accomplishmentDeadline
          )
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      } else {
        this.accomplishmentDeadline.deadline = this.getDate(
          this.accomplishmentDeadline.deadline
        );
        await this.$store
          .dispatch(
            "submissiondeadline/CreateSubmissionDeadline",
            this.accomplishmentDeadline
          )
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      }
    },
    async saveReturnDeadline() {
      if (
        this.returnDeadline.deadline == "" ||
        this.returnDeadline.deadline == null
      ) {
        if (this.returnDeadline.id) {
          await this.$store
            .dispatch(
              "submissiondeadline/DeleteSubmissionDeadline",
              this.returnDeadline.id
            )
            .then((res) => {
              if (res.data.error) {
                this.error = 2;
                return this.showToast(res.data.errorMessage, "error");
              }
            })
            .catch((err) => {
              this.error = 1;
            });
        }
      } else if (this.returnDeadline.id) {
        this.returnDeadline.deadline = this.getDate(
          this.returnDeadline.deadline
        );
        await this.$store
          .dispatch(
            "submissiondeadline/UpdateSubmissionDeadline",
            this.returnDeadline
          )
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      } else {
        this.returnDeadline.deadline = this.getDate(
          this.returnDeadline.deadline
        );
        await this.$store
          .dispatch(
            "submissiondeadline/CreateSubmissionDeadline",
            this.returnDeadline
          )
          .then((res) => {
            if (res.data.error) {
              this.error = 2;
              return this.showToast(res.data.errorMessage, "error");
            }
          })
          .catch((err) => {
            this.error = 1;
          });
      }
    },
    async endSave() {
      if (this.error == 0) {
        this.$bvModal.hide("submission-deadline-modal");
        await this.showToast("Successfully saved!", "success");
      } else if (this.error == 1) {
        await this.showToast("Something went wrong!", "error");
      }
    },
    disabledRangeFrom(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
  },
};
</script>
<template>
  <b-modal
    id="submission-deadline-modal"
    :title="modalTitle"
    size="md"
    title-class="font-20"
    hide-footer
    no-close-on-backdrop
  >
    <div
      class="p-5 d-flex align-items-center justify-content-center"
      v-if="loading"
    >
      <div class="preloader-component me-2">
        <div class="status">
          <div class="spinner-chase w-25px h-25px">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <h5 class="mb-0">Loading...</h5>
    </div>
    <form v-else @submit.prevent="onSave" class="needs-validation" ref="fcForm">
      <div v-for="(deadline, index) in deadlineList" :key="index">
        <div class="bg-secondary text-center py-2 text-white">
          {{ deadline.label }}
        </div>
        <div class="px-2 border border-secondary border-top-0 pt-2 mb-3">
          <div class="mb-3">
            <label :for="`deadline-${index}`">Deadline </label>
            <date-picker
              :id="`deadline-${index}`"
              v-model="deadline.deadline"
              :first-day-of-week="1"
              lang="en"
              type="datetime"
              :disabled-date="disabledRangeFrom"
              placeholder="Enter Deadline..."
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Save changes</button>
      </div>
    </form>
  </b-modal>
</template>
